export enum EventRecurrenceDayEnum {
  su = 'SU',
  mo = 'MO',
  tu = 'TU',
  we = 'WE',
  th = 'TH',
  fr = 'FR',
  sa = 'SA'
}

//todo find where is better place for it
export enum EventRecurrenceFreqEnum {
  daily = 'DAILY',
  weekly = 'WEEKLY',
  monthly = 'MONTHLY',
  yearly = 'YEARLY'
}

export enum EventRecurrenceMonthEnum {
  jan = 1,
  feb = 2,
  mar = 3,
  apr = 4,
  may = 5,
  jun = 6,
  jul = 7,
  aug = 8,
  sep = 9,
  oct = 10,
  nov = 11,
  dec = 12
}

export const EventRecurrenceSundayWeekDays = [
  'SU',
  'MO',
  'TU',
  'WE',
  'TH',
  'FR',
  'SA'
]

export const EventRecurrenceMondayWeekDays = [
  'MO',
  'TU',
  'WE',
  'TH',
  'FR',
  'SA',
  'SU'
]
